export const AUTH = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  UPDATE_PRIVILEGES: 'UPDATE_PRIVILEGES',
  REMEMBER_ME: 'REMEMBER_ME',
}

